import { render, staticRenderFns } from "./LidDatail.vue?vue&type=template&id=d244300c&"
import script from "./LidDatail.vue?vue&type=script&lang=js&"
export * from "./LidDatail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports